import createAsyncActionType from '../utilities/createAsyncActionType';

export const CHECK_USER_ACTIVITY = createAsyncActionType('CHECK_USER_ACTIVITY');


// WEBPACK FOOTER //
// ./src/types/userActivityTypes.js